import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import GroupWorkOutlinedIcon from "@mui/icons-material/GroupWorkOutlined";
import HandymanIcon from "@mui/icons-material/Handyman";
import LaptopIcon from "@mui/icons-material/Laptop";
import LineStyleIcon from "@mui/icons-material/LineStyle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StraightenIcon from "@mui/icons-material/Straighten";
import TuneIcon from "@mui/icons-material/Tune";
import VillaIcon from "@mui/icons-material/Villa";
import { useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import RequestCollabModal from "../../suspense/RequestCollabModal";
import { getProfessionalById } from "../../../service/MainService";
import axios from "axios";

const ProjectInfo = ({ projectDetails }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(projectDetails.LikesCount);

  const projectStat = [
    {
      id: 1,
      icon: <AccountCircleIcon />,
      title: "Architect",
      desc: projectDetails?.user?.UserName || "NA",
    },
    {
      id: 2,
      icon: <StraightenIcon />,
      title: "Area",
      desc: projectDetails.Area || "NA",
    },
    {
      id: 3,
      icon: <LineStyleIcon />,
      title: "Material",
      desc: projectDetails.Materials || "NA",
    },
    {
      id: 4,
      icon: <VillaIcon />,
      title: "Typology",
      desc: projectDetails.TypologyCategory || "NA",
    },
    {
      id: 11,
      icon: <VillaIcon />,
      title: "Sub-Typology",
      desc: projectDetails.TypologySubCategory || "NA",
    },
    {
      id: 5,
      icon: <CalendarMonthIcon />,
      title: "Year",
      desc: projectDetails.Years || "NA",
    },
    {
      id: 6,
      icon: <TuneIcon />,
      title: "Style",
      desc: projectDetails.Style || "NA",
    },
    {
      id: 7,
      icon: <HandymanIcon />,
      title: "Phase",
      desc: projectDetails.Phase || "NA",
    },
    {
      id: 8,
      icon: <LaptopIcon />,
      title: "Modeling",
      desc: projectDetails?.Modeling || "NA",
    },
    {
      id: 9,
      icon: <LaptopIcon />,
      title: "Rendering",
      desc: projectDetails?.Rendering || "NA",
    },
    {
      id: 10,
      icon: <LocationOnIcon />,
      title: "Location",
      desc: projectDetails?.Country?.countryName || "NA",
    },
  ];

  const firstColumn = projectStat.slice(0, 4);
  const secondColumn = projectStat.slice(4, 8);
  const thirdColumn = projectStat.slice(8);
  const columns = [firstColumn, secondColumn, thirdColumn];

  const handleClick = () => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setOpen(true);
    } else {
      navigate("/login");
    }
  };

  const navigateToProfessionalDetail = async (userId, event) => {
    try {
      event.preventDefault();

      const token = localStorage.getItem("accessToken");
      const userDetails = await getProfessionalById(userId, token);

      navigate(`/professionals/${userId}`, {
        state: { userDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  const handleLike = async () => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      try {
        const userId = parseInt(localStorage.getItem("userId"));
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}api/like-project`,
          { ProjectId: projectDetails.ProjectId, UserId: userId }
        );
        const { value, likesCount } = response.data.body;
        if (value === "Project liked successfully") {
          setLiked(true);
          setLikesCount(likesCount);
          toast.success("project liked");
        } else if (value === "Project unliked successfully") {
          setLiked(false);
          setLikesCount(likesCount);
        }
      } catch (error) {
        console.error("Error occurred while liking project:", error);
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <div>
        <img
          src={
            projectDetails.Image1
              ? projectDetails.Image1
              : projectDetails.ImageUrls && projectDetails.ImageUrls.length > 0
              ? projectDetails.ImageUrls[0]
              : undefined
          }
          alt={projectDetails.ProjectName || "Project"}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col items-center justify-center gap-6 py-10 border-b-2 border-gray-300">
        <nav className="flex" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
            <li aria-current="page">
              <div className="flex items-center">
                <Link
                  to="/"
                  className="ms-1 text-md font-medium text-gray-500 md:ms-2 dark:text-gray-400"
                >
                  Home
                </Link>
              </div>
            </li>
            <li aria-current="page">
              <div className="flex items-center">
                <IoIosArrowForward />
                <Link
                  to="/projects"
                  className="ms-1 text-md font-medium text-gray-500 md:ms-2 dark:text-gray-400"
                >
                  Projects
                </Link>
              </div>
            </li>
            <li aria-current="page">
              <div className="flex items-center">
                <IoIosArrowForward />
                <Link className="ms-1 text-md font-medium text-gray-500 md:ms-2 dark:text-gray-400">
                  {projectDetails.ProjectName}
                </Link>
              </div>
            </li>
          </ol>
        </nav>
        <div className="flex items-center">
          <div className="text-3xl border-r border-gray-400 pr-4">
            {projectDetails.ProjectName}
          </div>
          <div className="flex items-center gap-4 text-gray-500 text-lg cursor-pointer font-semibold pl-4">
            <button onClick={handleLike}>
              {liked ? (
                <FavoriteIcon style={{ color: "red" }} />
              ) : (
                <FavoriteBorderIcon />
              )}
              ({likesCount})
            </button>
            <GroupWorkOutlinedIcon
              className="cursor-pointer"
              onClick={handleClick}
            />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-28 mt-5">
          {columns.map((column, index) => (
            <div key={index} className="flex flex-col items-start gap-4">
              {column.map((item) => (
                <div key={item.id} className="flex items-center gap-2">
                  <div className="text-gray-500 text-xl">{item.icon}</div>
                  <div className="text-md text-gray-500">{item.title}:</div>
                  {item.title === "Architect" ? (
                    <div className="text-sm text-blue-800 underline font-semibold">
                      <Link
                        onClick={(event) =>
                          navigateToProfessionalDetail(
                            projectDetails.user.UserId,
                            event
                          )
                        }
                      >
                        {item.desc}
                      </Link>
                    </div>
                  ) : (
                    <div className="text-sm text-gray-800 font-semibold">
                      {item.desc}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <RequestCollabModal
        open={open}
        setOpen={setOpen}
        projectDetails={projectDetails}
      />
    </>
  );
};

export default ProjectInfo;
